module.exports = require("./kgp");